import ApiService from "./../api/ApiService";
import Config from "../constants/Config";
import Urls from "./../api/Urls";

const headers = {
  tenantId: Config.HOTEL_TENANT_ID,
};

export function campaignAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_PROMOTION,
    endpoint: Urls.CAMPAIGN_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function hotelAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.HOTEL_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function roomTypeAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.ROOM_TYPE_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function tourAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.TOUR_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function tourTicketAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.TOUR_TICKET_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function supplierAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.SUPPLIER_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function menuAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_TOUR,
    endpoint: Urls.FNB_MENU_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function tagGroupDetailAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function vinWonderTagGroupAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.VIN_WONDER_TAGGROUP_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function ratePlanAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_PROMOTION,
    endpoint: Urls.RATE_PLAN_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}

export function bookablePackageRateAutoTranslate(params) {
  const payload = {
    SourceId: params.sourceId,
    SourceLanguage: params.sourceLanguage,
    TargetLanguages: params.targetLanguages,
  };

  return new ApiService({
    baseURL: Config.API_HOTEL,
    endpoint: Urls.BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE,
    headers,
    parser: (response) => response,
  }).post(payload);
}
